import { AxiosResponse } from "axios";
import { BASE_METHODS, CustomErrorType } from "../../constants/action-types";
import { createCall } from "../base";
import { GetMeDTO } from "../../constants/dto/admin";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { store } from "../../store";
import {
  setAdminActionStart,
  setAdminErrorMessage,
} from "../../constants/reducers/admin.reducer";
import { TextEnum } from "../../constants/text";
import { timeoutError } from "../../constants/reducers/base.reducer";

type ModifyAdminProps = {
  password: string;
  name: string;
};

let body: GetMeDTO;

export const modifyAdmin = async (props: ModifyAdminProps) => {
  store.dispatch(setAdminActionStart(true));
  const { name, password } = props;

  const params = {
    name: name.trim(),
    password,
  };
  const request = await createCall(
    `cms/admins/modify`,
    BASE_METHODS.PUT,
    "application/json",
    "1.0.0",
    params
  );

  try {
    const response = request as AxiosResponse;
    body = plainToClass(GetMeDTO, response.data);
    const errors = await validate(body);

    if (errors.length > 0) {
      store.dispatch(
        setAdminErrorMessage(TextEnum.MODIFY_ADMIN_INVALID_RESPONSE)
      );
      return;
    }
    store.dispatch(setAdminErrorMessage(TextEnum.PROFILE_SUCCESS_MESSAGE));
    store.dispatch(setAdminActionStart(false));
    return response;
  } catch (error) {
    const responseError = request as any;
    const errorResponeData: CustomErrorType = responseError.response?.data;
    if (errorResponeData) {
      let errorMessage = "";
      switch (errorResponeData.code) {
        case 1001:
          errorMessage = TextEnum.MODIFY_ADMIN_USER_NOT_FOUND;
          break;
        default:
          break;
      }
      store.dispatch(setAdminErrorMessage(errorMessage));
      return;
    }
    store.dispatch(setAdminActionStart(false));
    store.dispatch(timeoutError());
    return;
  }
};
